/** A refused Configure-lane write (SA-416), worded ONCE for both bars. */
import { Button } from '@/components/ui'
import type { WriteConflict } from '@/utils/writeConflict'

export const CONFIG_CONFLICT_TEXT: Record<WriteConflict, string> = {
  stale:
    'Someone saved a newer configuration draft — reload to continue. Reloading replaces your unsaved changes.',
  base_moved:
    "This workflow's template was updated — reload to continue. Your edits are kept unless someone else also saved a draft.",
  published_since:
    'Someone published this workflow since you opened it. Reload to continue; your unsaved changes are kept unless someone else also saved a draft.',
}

export function ConfigConflictBanner({ conflict, reloading, onReload }: {
  conflict: WriteConflict
  reloading: boolean
  onReload: () => void
}) {
  return (
    <div role="alert" className="flex items-center justify-between gap-3 text-xs text-warning-strong">
      <span>{CONFIG_CONFLICT_TEXT[conflict]}</span>
      <Button size="sm" variant="outline" isLoading={reloading} onClick={onReload}>
        Reload
      </Button>
    </div>
  )
}
